import { render, staticRenderFns } from "./NoStatisticMappingMessage.vue?vue&type=template&id=71c9e30e&scoped=true&"
import script from "./NoStatisticMappingMessage.vue?vue&type=script&lang=ts&"
export * from "./NoStatisticMappingMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c9e30e",
  null
  
)

export default component.exports